import { getI18n } from '@editor/ui-utils';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  // route example
  // should be removed later
  { path: '', redirect: '/articles' },
  {
    path: '/data-check',
    name: 'data_check',
    component: () => import('@/components/data-integrity.view.vue'),
    meta: { requiredRight: 'data_check' },
  },
];

const router = createRouter({ history: createWebHistory(), routes });
router.beforeEach((to, from, next) => {
  const i18key = to.meta.i18RouteTitleKey;

  if (to.path !== from.path) {
    // Check if the route exists in i18n messages
    const keyExists = getI18n().te(`${i18key}.routeTitle`);
    document.title = keyExists ? getI18n().t(`${i18key}.routeTitle`) : 'Burda Forward Editor';
  }

  next();
});

export default router;
